import isEmpty from 'lodash/isEmpty';

import {
  GET_NARVAR_PREFERENCES_RESPONSE,
  CREATE_NARVAR_PREFERENCES_REQUEST,
  CREATE_NARVAR_PREFERENCES_ERROR,
  UPDATE_NARVAR_PREFERENCES_REQUEST,
  UPDATE_NARVAR_PREFERENCES_ERROR,
} from 'actions/narvar';

const initialState = {
  modifiedDatetime: '',
  smsOptIn: false,
};

export default (state = initialState, action) => {
  const { response, type } = action;

  switch (type) {
    case CREATE_NARVAR_PREFERENCES_REQUEST:
      return { ...state, smsOptIn: true };
    case UPDATE_NARVAR_PREFERENCES_REQUEST:
      return { ...state, smsOptIn: checkForOptIn(action.params.options) };
    case GET_NARVAR_PREFERENCES_RESPONSE:
      return {
        ...state,
        smsOptIn: transformOptIn(response.customerPreferences),
        modifiedDatetime: transformModifiedDateTime(response.customerPreferences),
      };
    case UPDATE_NARVAR_PREFERENCES_ERROR:
      return { ...state, smsOptIn: !state.smsOptIn };
    case CREATE_NARVAR_PREFERENCES_ERROR:
      return { ...state, smsOptIn: false };
    default:
      return state;
  }
};

const checkForOptIn = options => !isEmpty(options);
const transformModifiedDateTime = pref =>
  pref && pref.modifiedDatetime ? pref.modifiedDatetime : '';
const transformOptIn = pref =>
  pref && pref.notificationPrefDetails && !!pref.notificationPrefDetails.length ? true : false;
